import { createRouter } from '@tanstack/react-router';

import { routeTree } from '@/routeTree.gen';

export const router = createRouter({
  routeTree,
  context: {
    confirmationStore: undefined!,
    childRoutes: [],
    groupLabel: '',
    queryClient: undefined!,
    client: undefined!,
    perms: undefined!,
    dialogFormStore: undefined!,
    auth: undefined!,
  },
});
